const EMPTY_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
const CDN_PRISMIC_DEPRECATED = 'https://maisonsdumonde.cdn.prismic.io/';
const CDN_PRISMIC = 'https://images.prismic.io/maisonsdumonde/';
const CDN_MDM = 'cdn.maisonsdumonde.com';
const MEDIA_PATH = 'https://medias.maisonsdumonde.com'; // eslint-disable-next-line

export { EMPTY_PIXEL, CDN_PRISMIC_DEPRECATED, CDN_PRISMIC, CDN_MDM, MEDIA_PATH };
export const IMAGE_SIZES = {
  THUMBNAIL: 100,
  XS: 200,
  S: 350,
  M: 500,
  L: 1000,
  XL: 1500
};